/**
 * Role Domain Constants
 * Single source of truth for role and privilege-related constants
 */

// Strategies for handling user privileges when roles change
export const PRIVILEGE_CHANGE_STRATEGIES = {
  RESET: 'reset',
  SYNC: 'sync',
  KEEP: 'keep',
};

// Privilege types (internal vs external)
export const PRIVILEGE_TYPES = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
};

export const ROLE_STATUS = {
  PUBLISHED_ACTIVE: 'published_active',
  PUBLISHED_DEACTIVATED: 'published_deactivated',
  NOT_PUBLISHED: 'not_published',
};
